import { Controller } from "@hotwired/stimulus";
import { Modal } from "bootstrap";

export default class extends Controller {
  static targets = ["emailBallotCode", "emailUserName", "emailInput", "emailWarning", "sendEmailButton", "useDefaultButton"]
  static values = { electionId: Number }

  connect() {
    const emailConfirmationModalElement = document.getElementById('emailConfirmationModal')
    this.emailConfirmationModal = new Modal(emailConfirmationModalElement)
  }

  confirmSendBallotEmail(event) {
    event.preventDefault()
    this.currentBallotId = event.currentTarget.dataset.ballotId
    const ballotCode = event.currentTarget.dataset.ballotCode
    const userName = event.currentTarget.dataset.userName
    const userEmail = event.currentTarget.dataset.userEmail

    // Set ballot info in email confirmation modal
    this.emailBallotCodeTarget.textContent = ballotCode
    this.emailUserNameTarget.textContent = userName
    this.defaultUserEmail = userEmail

    // Check if user has email and populate the input field
    if (userEmail && userEmail !== 'null' && userEmail !== '') {
      this.emailInputTarget.value = userEmail
      this.emailWarningTarget.style.display = 'none'
      this.sendEmailButtonTarget.disabled = false
      this.useDefaultButtonTarget.disabled = false
    } else {
      this.emailInputTarget.value = ''
      this.emailWarningTarget.style.display = 'block'
      this.sendEmailButtonTarget.disabled = false // Allow sending to custom email even if no default
      this.useDefaultButtonTarget.disabled = true
    }

    // Show email confirmation modal
    this.emailConfirmationModal.show()
  }

  useDefaultEmail(event) {
    event.preventDefault()
    if (this.defaultUserEmail && this.defaultUserEmail !== 'null' && this.defaultUserEmail !== '') {
      this.emailInputTarget.value = this.defaultUserEmail
    }
  }

  async sendBallotEmail(event) {
    event.preventDefault()

    // Get the email from the input field
    const emailAddress = this.emailInputTarget.value.trim()

    // Validate email address
    if (!emailAddress) {
      alert('Please enter an email address.')
      return
    }

    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/
    if (!emailRegex.test(emailAddress)) {
      alert('Please enter a valid email address.')
      return
    }

    // Disable button and show loading state
    const button = event.currentTarget
    button.disabled = true
    const originalContent = button.innerHTML
    button.innerHTML = '<span class="spinner-border spinner-border-sm me-2"></span>Sending...'

    try {
      const csrfToken = document.querySelector('[name="csrf-token"]')?.content || ''
      const response = await fetch(`/admin/elections/${this.electionIdValue}/election_ballots/${this.currentBallotId}/send_ballot_email`, {
        method: 'POST',
        headers: {
          'X-CSRF-Token': csrfToken,
          'Accept': 'application/json',
          'Content-Type': 'application/json'
        },
        body: JSON.stringify({
          email: emailAddress
        })
      })

      const data = await response.json()

      if (response.ok) {
        // Success - hide modal and show success message
        this.emailConfirmationModal.hide()

        // You could show a toast notification here
        alert(`Email sent successfully to ${data.email}`)
      } else {
        // Error - show error message
        alert(`Error: ${data.error}`)
      }

    } catch (error) {
      console.error('Error sending email:', error)
      alert('Failed to send email. Please try again.')
    } finally {
      // Re-enable button and restore original content
      button.disabled = false
      button.innerHTML = originalContent
    }
  }
}
